export default {
    namespaced: true,

    state: {
        errorBags: {}
    },

    getters: {
        getError: (state) => {
            return (key) => state.errorBags[key]
        }
    },

    mutations: {
        ['FORM_ERRORS_SET'](state, {key, errors}) {
            state.errorBags = {...state.errorBags, [key]: errors};
        },
        ['FORM_ERRORS_CLEAR'](state, key) {
            if (state.errorBags[key]) {
                state.errorBags[key] = null;
            }
        }
    }
}
